require('../_design_files/scss/card-list.scss');
let bgCardUrl = require('../_design_files/img/card-bg.svg');
angular.module('eatself').component('cardList',{
	bindings: {
		cards: '<',
		setCard: '&',
		selectedCard: '<',
		cardRefused: '<',
		gotoNewCard: '&',
	},
	controllerAs: 'vm',	
	controller: angular.module('eatself').classy.controller({
		inject: ['$scope','$timeout'],
		init() {
			this.bgCardUrl = bgCardUrl;
		},
		methods: {
			$onInit() {
				this.carouselOptions = {
					startPosition: this.selectedCard ? _.indexOf(this.cards, this.selectedCard): 0,
					center: true,
					loop: false,
					items: 2,
					responsiveClass: true,
					// mouseDrag: false,
					dots: true,
					responsiveBaseElement: ".cardCarousel",
					// responsive: {
					// 	0: { items: 1, },
					// 	400: { items: 1, },
					// 	600: { items: 1, },
					// 	768: { items: 1, },
					// }
				};
				this.$scope.$watch(_=>this.cards,_ => {
					// need to recreate owlCarousel after each cards list change, because its a new array, which owlCarousel doesnt have 
					// a reference to. previously, it couldn't update the html simply based on ng-repeat changes
					$('.cardCarousel').trigger('destroy.owl.carousel');
					this.$timeout(_ => $('.cardCarousel').owlCarousel(this.carouselOptions));
				});
			},
			toggleCard(card) {
				if (card === this.selectedCard) {
					this.setCard({card: null});
				} else {
					this.setCard({card: card });
				}
				$('.cardCarousel').trigger('to.owl.carousel', [ _.indexOf(this.cards, card) ]);
			},
		}
	}),
	template: require('../templates/card-list.html'),	
})